<template>
  <div class="webhook-logs">
    <i v-if="!value.length" class="fade">{{ $t('noLogs') }}</i>
    <DataTable
      v-if="value.length"
      theme="border"
      :header="false"
      :columns="[{ id: 'status' }, { id: 'date' }, { id: 'message', size: '1fr' }, { id: 'cancel' }]"
      :value="value"
    >
      <template #status="{ item }">
        <FontAwesomeIcon :title="item.status" v-bind="iconMap[item.status] || { icon: 'question-circle' }" />
      </template>
      <template #date="{ item }">
        <div class="col">
          <div class="text--small fade">{{ item.event }}</div>
          <div>{{ item.date | Moment('LLL') }}</div>
        </div>
      </template>
      <template #message="{ item }">
        <div>
          <div v-if="item.status === 'delayed'" class="webhook-log__delayed">
            {{ $t('attempt') }}: {{ item.attemptsMade }} {{ $t('of') }}
            {{ item.attemptsMade + item.attemptsRemaining }}
          </div>
          <div v-if="item.message" :title="item.message" class="webhook-log__reason">
            {{ item.message.length > 100 ? item.message.substring(0, 100) + '...' : item.message }}
          </div>
        </div>
      </template>
      <template #cancel="{ item }">
        <ButtonComponent
          v-if="!['completed', 'failed'].includes(item.status)"
          :icon="['fal', 'times']"
          :promise="promises[item.id]"
          confirm
          style="font-size: 0.7em"
          v-tooltip.bottom="$t('cancel')"
          @click="remove(item)"
        />
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable'
import { Moment } from '@/filters'
import API from '@/api/Webhook'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      promises: {},
      iconMap: {
        completed: { icon: 'check-circle', class: 'text--success' },
        failed: { icon: 'exclamation-triangle', class: 'text--error' },
        delayed: { icon: ['fal', 'spinner-third'], spin: true },
      },
    }
  },
  methods: {
    remove(item) {
      this.promises[item.id] = API.removeJob({ webhookId: this.$store.state.Webhook.item.id, id: item.id }).then(() => {
        item.status = 'failed'
        item.message = 'Aborted by user'
      })
    },
  },
  components: {
    DataTable,
  },
  filters: {
    Moment,
  },
}
</script>

<style lang="scss">
.webhook-logs {
  width: 100%;
  max-height: 850px;
  overflow-y: scroll;
  @include scrollShadow();

  .webhook-log {
    &__reason {
      font-size: 0.7rem;
      padding: 0.25rem 0.4rem;
      background-color: css-lighten('border-color', 5%);
      border-radius: var(--border-radius);
    }

    &__delayed {
      margin-bottom: 0.25rem;
      opacity: 0.7;
      font-size: 0.7rem;
    }
  }
}
</style>
